
  <div  class="home-container">
    <div id="home">
      <p class="home-title"> Welcome to NISH Technologies</p>
      <div class="row">
        <div class="col-4">
          <img class="nish-logo" style="max-width: 100%" alt="nish-logo" src="./assets/images/nishtechcard-768x439.jpg">
        </div>
        <div class="col-8 margin-auto">
          <p class="home-description">NISH Technologies is a global IT sourcing and training organisation providing onshore, offshore, nearshore services and training courses on niche skills stack through well versed industry experienced leaders.</p>
          <p class="home-description">Our business model is to identify bespoke associates, train and provide services across EMEA and Asia-Pacific geographical regions.</p>
        </div>
      </div>

    </div>
  </div>
